import React, { useEffect } from 'react';
import { reviewService } from '../services/reviewService.ts';
import { useReviewer } from '../context/ReviewerContext.tsx';

export const Init: React.FC = ({}) => {
    const { setCurrentReviewer } = useReviewer();

    const fetchReviewers = async () => {
        const data = await reviewService.getReviewer();
        setCurrentReviewer(data);
    };

    useEffect(() => {
        fetchReviewers();
    }, []);

    return <div></div>;
};
